import './list.scss';

import React from 'react';

interface Props {
  items: React.ReactNode[];
}

export function List({ items }: Props): JSX.Element {
  return (
    <ul className="list">
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
}
